import React from 'react';
import { socialLinks } from '../data/navigation';
interface SocialLinksProps {
  variant?: 'footer' | 'menu';
}
const scaleClass = {
  smaller: 'scale-90',
  normal: '',
  bigger: 'scale-110'
};
export function SocialLinks({
  variant = 'footer'
}: SocialLinksProps) {
  return <ul className="flex flex-wrap gap-[0.9375rem]" data-id="element-189" data-mp="gw84lyq1yt3v">
      {socialLinks.map(social => <li key={social.label} data-id="element-190" data-mp="1ejyxnmi622t3">
          <a href={social.href} target="_blank" rel="noreferrer" aria-label={social.label} className={`group relative flex h-[2.125rem] w-[2.125rem] items-center justify-center overflow-hidden rounded-full transition-[filter,background-color] duration-200 ${variant === 'menu' ? 'bg-white hover:invert' : 'bg-navy/5'}`} data-id="element-191" data-mp="1ek8eajhbmxm4">
            {variant === 'footer' && <span className="absolute inset-0 rounded-full bg-black opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-192" data-mp="1xcavpx1sehxf" />}
            <img src={social.icon} alt="" width={17} className={`relative z-10 w-[17px] transition-[filter] duration-200 ${scaleClass[social.scale]} ${variant === 'footer' ? 'group-hover:invert' : ''}`} data-id="element-193" data-mp="1yj1nogkd1u0l" />
          </a>
        </li>)}
    </ul>;
}